<template>
  <div class="p-field p-col-3 p-md-1 status-container">
    <AppFormItem label="Concluído">
      <InputSwitch
        :modelValue="done"
        @update:modelValue="$emit('update:done', !done)"
      ></InputSwitch>
    </AppFormItem>
  </div>
</template>

<script>
export default {
  name: 'ServiceEditStatus',
  props: {
    done: Boolean,
  },
};
</script>

<style>
</style>
